/**
 * @param {object} props
 * @param {object[]} props.selections
 * @param {object} props.question
 * @param {(choice: string, questionId: number) => void} props.selectChoice
 * @param {string} [props.placeholder] Placeholder text for the input field.
 * @param {React.HTMLInputTypeAttribute} [props.inputType] Type of input field.
 * @param {boolean} [props.integerOnly] `true` to only allow integer input.
 */
const SurveyTextboxChoices = ({ selections, question, selectChoice, placeholder, inputType = "text", integerOnly }) => {
    function handleSelectChoice(choice) {
        if (selectChoice) {
            selectChoice(choice, question.id);
        }
    }

    return (
        <input
            aria-label={placeholder}
            className="c-box w-[154px] h-[40px]"
            type={inputType}
            onKeyDown={
                integerOnly &&
                ((event) => {
                    if (
                        !(event.shiftKey || event.altKey || event.ctrlKey) && // Allow shift, alt, and ctrl actions
                        !/\d|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Backspace|Delete|Home|End/.test(event.key) // Only allow numbers, arrow keys, backspace and delete
                    ) {
                        event.preventDefault();
                    }
                })
            }
            placeholder={placeholder}
            onChange={(e) => handleSelectChoice(e.target.value)}
            value={selections && selections[question.id] ? selections[question.id] : ""}
        />
    );
};

export default SurveyTextboxChoices;
